import { FC, useState } from 'react'
import GoBackHeader from 'components/organisms/GoBackHeader'
import { useMutation } from '@apollo/client'
import { useHistory } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from 'hooks/store'
import {
  UPDATE_QUESTIONNAIRE_SHOWN_TERMSANDCONDITIONS_FLAG,
  UpdateQuestionnaireShownTermsAndConditionsFlagVariables,
  UpdateQuestionnaireShownTermsAndConditionsFlagResponse
} from 'share/mutations/cases'
import { setQuestionnaireShownTermsAndConditionsFlag } from 'reducers/activecase/activecaseSlice'
import Button from 'react-bootstrap/Button'
import {
  QuestionnaireTermsAndConditionsContainer,
  QuestionnaireTermsAndConditionsPage
} from './styles'
import { TwoBtnsOrderedContainer } from 'components/atoms/Layout'
import { Form } from 'react-bootstrap'
import { QUESTIONNAIRE_TERMS_AND_CONDITION_TEXT } from '../constants'

const QuestionnaireTermsAndConditions: FC = () => {
  const activeCase = useAppSelector((state) => state.activeCase)
  const dispatch = useAppDispatch()
  const history = useHistory()
  const [isEnabled, setIsEnabled] = useState(false)
  const [updateShownTermsAndConditionsFlag] = useMutation<
    UpdateQuestionnaireShownTermsAndConditionsFlagResponse,
    UpdateQuestionnaireShownTermsAndConditionsFlagVariables
  >(UPDATE_QUESTIONNAIRE_SHOWN_TERMSANDCONDITIONS_FLAG)

  async function updateShownTermsAndConditionsFlagHelper(): Promise<boolean> {
    let result = false
    try {
      const input = {
        flag: true,
        caseId:
          activeCase.matter && activeCase.matter.id ? activeCase?.matter.id : 0
      }

      const updateResult = await updateShownTermsAndConditionsFlag({
        variables: { request: input }
      })
      if (
        updateResult.data?.cases.updateQuestionnaireShownTermsAndConditionsFlag
          .success
      ) {
        result = true
        if (activeCase) {
          if (activeCase.matter) {
            dispatch(setQuestionnaireShownTermsAndConditionsFlag(true))
          }
        }
      }
    } catch (e) {
      result = false
    }

    return result
  }

  async function continueClick() {
    await updateShownTermsAndConditionsFlagHelper()
    history.push('/dashboard/questionnaires')
  }

  function goBackHeaderOnClick() {
    history.push('/dashboard/questionnaires/introduction')
  }

  return (
    <>
      <GoBackHeader
        text='Bankruptcy Questionnaire'
        onClick={goBackHeaderOnClick}
      />
      <QuestionnaireTermsAndConditionsPage>
        <h2>Terms & Conditions</h2>
        <QuestionnaireTermsAndConditionsContainer>
          {QUESTIONNAIRE_TERMS_AND_CONDITION_TEXT}
        </QuestionnaireTermsAndConditionsContainer>
        <Form.Group controlId='acceptTerms' className='accept-terms'>
          <Form.Check
            type='checkbox'
            label='I agree to the Terms & Conditions'
            onChange={(event) => setIsEnabled(event.target.checked)}
            className='accept-terms-checkbox'
            data-testid='accept-terms-checkbox'
          />
        </Form.Group>
        <TwoBtnsOrderedContainer>
          <Button
            onClick={continueClick}
            disabled={!isEnabled}
            data-testid='continue-btn'
          >
            Continue
          </Button>
          <Button
            variant='outline-secondary'
            onClick={goBackHeaderOnClick}
            data-testid='back-btn'
          >
            Back
          </Button>
        </TwoBtnsOrderedContainer>
      </QuestionnaireTermsAndConditionsPage>
    </>
  )
}

export default QuestionnaireTermsAndConditions
